module.exports = __webpack_public_path__ + "static/img/new.479627cb.png";